import { requestGlobalInterrupt } from '../globalInterrupt'
import { getWaitForElementToAppearPromise } from '../interruptiblePromises'
import { evaluateXpath } from '../interruptibleXpath'

export const FACEBOOK_RATE_LIMIT_EXCEPTION_NAME = 'FacebookRateLimitException'

export class FacebookRateLimitException extends Error {
  constructor(message) {
    super(message)
    this.name = FACEBOOK_RATE_LIMIT_EXCEPTION_NAME
  }
}

async function getIsRateLimitedPromise(): Promise<void> {
  await getWaitForElementToAppearPromise(
    document,
    (node) =>
      evaluateXpath(
        node,
        "descendant-or-self::*[contains(text(), 'Temporarily Blocked')]",
      )[0],
    null,
  )

  throw new FacebookRateLimitException('Facebook has rate limited this account')
}

export function facebookRateLimitWrapper<T extends Array<any>, U>(
  fn: (...args: T) => Promise<U>,
): (...args: T) => Promise<U> {
  async function wrappedFn(...args: T): Promise<U> {
    const rateLimitPromise = getIsRateLimitedPromise()
    const originalPromise = fn(...args)

    await Promise.race([originalPromise, rateLimitPromise]).catch((error) => {
      if (error instanceof FacebookRateLimitException) {
        requestGlobalInterrupt('Facebook has rate limited this account')
      }
      throw error
    })

    return originalPromise
  }

  return wrappedFn
}
